import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface EmptyClassViewProps {
    onAdd: () => void;
}

export const ClassEmptyView = ({ onAdd }: EmptyClassViewProps) => {
    const { t } = useTranslation();
    return (
        <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center' height='100%' gap={2}>
            <Typography variant='h6'>{t('class.empty.title')}</Typography>
            <Typography color='text.secondary'>{t('class.empty.description')}</Typography>
            <Button variant='contained' startIcon={<AddIcon />} onClick={onAdd}>
                {t('class.title')}
            </Button>
        </Box>
    );
};
